document.addEventListener('turbolinks:load', function () {
    const allCanvas = document.querySelectorAll(".JohnHancock-canvas");

    allCanvas.forEach((canvas) => {
        let wrapper = canvas.closest('.JohnHancock-wrapper');
        let hidden_field = wrapper.querySelector(".JohnHancock-hidden");
        let clear_canvas = wrapper.querySelector(".clear-canvas");

        if (hidden_field) {
            const signaturePad = new SignaturePad(canvas);
            const base64Prefix = "data:image/png;base64,";
            const savedSignature = hidden_field.value.startsWith(base64Prefix)
                ? hidden_field.value
                : base64Prefix + hidden_field.value;

            const context = canvas.getContext("2d");

            // Load existing signature if present
            if (savedSignature) {
                const image = new Image();
                image.src = savedSignature;

                image.onload = function () {
                    if (isSafari() || isIosBrowser()) {
                        setTimeout(function () {
                            context.clearRect(0, 0, canvas.width, canvas.height);
                            context.drawImage(image, 0, 0, canvas.width, canvas.height);
                            console.log('Image rendered with delay on Safari');
                        }, 100); // Adjust delay as needed
                    } else {
                        context.clearRect(0, 0, canvas.width, canvas.height);
                        context.drawImage(image, 0, 0, canvas.width, canvas.height);
                    }
                };


                image.onerror = function () {
                    window.rollbar.error("Failed to load the image.");
                };
            }

            // Save signature on form submit
            const parent_form = canvas.closest("form");
            parent_form.addEventListener('submit', function () {
                const trimmedCanvas = trimCanvas(canvas);
                hidden_field.value = trimmedCanvas.toDataURL();
            });

            function resizeCanvas(canvas, signaturePad) {
                const savedContent = signaturePad.toDataURL(); // Save current canvas content

                canvas.width = Math.min(500, $(window).width()); // Adjust this logic as needed
                canvas.height = Math.min(300, $(window).height());

                // Restore the canvas content
                restoreCanvasContent(canvas, savedContent);
            }

            function restoreCanvasContent(canvas, savedContent) {
                var image = new Image();
                image.src = savedContent;

                image.onload = function () {
                    if (isSafari() || isIosBrowser()) {
                        setTimeout(function () {
                            context.clearRect(0, 0, canvas.width, canvas.height);
                            context.drawImage(image, 0, 0, canvas.width, canvas.height);
                            console.log('Image rendered with delay on Safari');
                        }, 100); // Adjust delay as needed
                    } else {
                        context.clearRect(0, 0, canvas.width, canvas.height);
                        context.drawImage(image, 0, 0, canvas.width, canvas.height);
                    }
                };

                image.onerror = function () {
                    console.error("Failed to load the image.");
                };
            }

            var width = $(window).width(), height = $(window).height();
            window.addEventListener("resize", function () {
                if ($(window).width() != width || $(window).height() != height) {
                    resizeCanvas(canvas, signaturePad); // Adjust this to match your current setup
                }
            });

            clear_canvas?.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                context.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
            });

            function trimCanvas(canvas) {
                const padding = 10
                const ctx = canvas.getContext('2d');
                const width = canvas.width;
                const height = canvas.height;
                const imageData = ctx.getImageData(0, 0, width, height);
                const data = imageData.data;

                let top = null, left = null, right = null, bottom = null;

                for (let y = 0; y < height; y++) {
                    for (let x = 0; x < width; x++) {
                        const index = (y * width + x) * 4;
                        const alpha = data[index + 3];
                        if (alpha !== 0) {
                            if (top === null) top = y;
                            if (left === null || x < left) left = x;
                            if (right === null || x > right) right = x;
                            if (bottom === null || y > bottom) bottom = y;
                        }
                    }
                }

                // No signature present
                if (top === null) return canvas;

                // Add padding and clamp within bounds
                left = Math.max(0, left - padding);
                top = Math.max(0, top - padding);
                right = Math.min(width - 1, right + padding);
                bottom = Math.min(height - 1, bottom + padding);

                const trimmedWidth = right - left + 1;
                const trimmedHeight = bottom - top + 1;

                const trimmedCanvas = document.createElement('canvas');
                trimmedCanvas.width = trimmedWidth;
                trimmedCanvas.height = trimmedHeight;

                const trimmedCtx = trimmedCanvas.getContext('2d');
                trimmedCtx.fillStyle = 'rgba(255, 255, 255, 0)'; // Transparent background
                trimmedCtx.fillRect(0, 0, trimmedWidth, trimmedHeight);
                trimmedCtx.drawImage(canvas, left, top, trimmedWidth, trimmedHeight, 0, 0, trimmedWidth, trimmedHeight);

                return trimmedCanvas;
            }
        }
    });

    function isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    function isIosBrowser() {
        return (/iPad|iPhone|iPod/.test(navigator.userAgent))
    }
});